import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';

import {
    NotificationBarButtonContainer,
    NotificationBarContainer,
    NotificationBarText,
    NotificationBarTextContainer,
    notificationBarVariants,
} from '../../job-architecture-v2';

export const LearningOpportunityPublishNotification: FunctionComponent<{
    readonly disabled?: boolean;
    readonly onPublish: () => void;
}> = ({ disabled = false, onPublish }) => {
    const translate = useTranslate();

    return (
        <NotificationBarContainer
            animate={notificationBarVariants.animate}
            exit={notificationBarVariants.exit}
            initial={notificationBarVariants.initial}
        >
            <NotificationBarTextContainer>
                <NotificationBarText>
                    {translate('pages.learning-opportunities.publish-notification')}
                </NotificationBarText>
            </NotificationBarTextContainer>
            <NotificationBarButtonContainer>
                <Button disabled={disabled} variant="primary" onClick={onPublish}>
                    {translate('pages.learning-opportunities.publish-button')}
                </Button>
            </NotificationBarButtonContainer>
        </NotificationBarContainer>
    );
};
